export default (url, quality = .5) => {
    let image = new Image();
    image.src = url;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    let LastUrl;
    return new Promise((resolve, reject) => {
        image.onload = function () {
            const w = image.naturalWidth;
            const h = image.naturalHeight;
            canvas.width = w;
            canvas.height = h;
            ctx.drawImage(image, 0, 0, w, h, 0, 0, w, h);
            LastUrl = canvas.toDataURL("image/jpeg", quality);
            resolve(LastUrl)
        }
    })
}


// WEBPACK FOOTER //
// ./src/assets/js/compress.js